import type { RestApiError } from "../../../shared/dtos/error-response.dto";
import type { PagedResponseDto } from "../../../shared/dtos/paged-response.dto";
import { normalizeApiError } from "../../../shared/utils/normalize-api-error";
import type { ITechOperationDto } from "../shared/dtos/tech-operation.dto";

export type TechOperationAgregatedsV2Error = RestApiError;

export type TechOpsPagedResponseDto = PagedResponseDto<ITechOperationDto> & {
  aggregations?: { totalArea: number | null };
};

function isErrorRecord(res: unknown): res is Record<string, unknown> {
  return typeof res === "object" && res !== null;
}

export function isTechOperationNotFoundError(ex: unknown): boolean {
  return isErrorRecord(ex) && typeof ex.status === "number" && ex.status === 404;
}

export function getUpsertTechOperationErrorMessage(
  exception: unknown
): string | undefined {
  return isErrorRecord(exception) &&
    exception.status === "CUSTOM_ERROR" &&
    typeof exception.error === "string"
    ? exception.error
    : undefined;
}

export const transformAgregatedsV2ErrorResponse = (
  baseQueryReturnValue: unknown
): string | TechOperationAgregatedsV2Error => {
  return normalizeApiError(baseQueryReturnValue).error;
};
